import React, { useState, useEffect } from "react";

export const Mandamientos = () => {
    const [width, setWidth] = useState(1024);

    useEffect(() => {
        const windowEvent = window.addEventListener("resize", () => {
            setWidth(window.innerWidth);
        });
        return window.removeEventListener("resize", () => {
            setWidth(window.innerWidth);
        });
    }, []);

    return (
        <div className="mandamientos">
            <img
                className="header"
                src={`/images/background/mandamientos_${
                    width <= 576 ? "mobile" : "desktop"
                }.jpg`}
                alt="Mandamientos FIAT PLAN"
            />
            <div className="body-head">
                <h1 className="subtitle">MANDAMIENTOS FIAT PLAN</h1>
                <h2 className="title">
                    QUE TU PLAN PARA TENER UN AUTO SEA TAN CLARO COMO LAS GANAS
                    DE TENERLO
                </h2>
                <p className="desc">
                    FIAT PLAN lanzó la campaña “MANDAMIENTOS FIAT PLAN” con el
                    fin de poder concientizar a todos los clientes sobre los
                    principales puntos que generan consultas y dudas sobre el
                    plan de ahorro. A continuación, se encuentran detallados
                    cada uno de los Mandamientos que podrán ver en nuestro
                    video.
                </p>
            </div>
            <div className="body-mandamientos">
                <div className="mandamiento">
                    <h2 className="title">
                        NO COMPARTIRÁS INFORMACIÓN PERSONAL O FINANCIERA A QUIEN
                        TE LLAMA POR TELÉFONO, MENSAJES O EN NOMBRE DE FIAT
                    </h2>
                    <p className="desc">
                        ¡Cuidado con los fraudes! Si te contactan a través de
                        mensajes, llamadas o redes sociales, primero corroborá
                        su autenticidad con tu concesionario o comunícate con
                        nosotros al{" "}
                        <span className="telefono">0800 222 3428</span> o por
                        mail a{" "}
                        <a href="mailto:fiatplan@clientefca.com.ar">
                            fiatplan@clientefca.com.ar
                        </a>{" "}
                        y no des información personal o financiera ni efectúes
                        pagos. En caso de recibir un mail sospechoso, no
                        ingreses tus datos ni descargues adjuntos ni ingreses en
                        links.
                        <br /> FIAT PLAN no solicita a los clientes ninguna
                        información personal o financiera por teléfono o
                        mensajes u otros canales de comunicación. Esta
                        información, el cliente la brinda en la Solicitud de
                        Adhesión al suscribir en los concesionarios oficiales o
                        en nuestra plataforma de Suscripción Online.
                        <br /> En nuestra sección CONCESIONARIOS encontrarás
                        toda los datos de nuestra red habilitada para la
                        comercialización y gestión de nuestros planes de ahorro.
                    </p>
                </div>
                <div className="mandamiento">
                    <h2 className="title">
                        TAMPOCO SACARÁS UN PLAN DE AHORRO EN UN CONCESIONARIO NO
                        OFICIAL NI CREERÁS QUE EXISTE CASA CENTRAL O DESCUENTOS
                        DIRECTO DE FÁBRICA.
                    </h2>
                    <p className="desc">
                        Nuestros planes de ahorro se comercializan única y
                        exclusivamente en la red de concesionarios oficial de
                        FIAT (
                        <a
                            href="https://fiat-ar-prod-fca.adobecqms.net/concesionarios.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://fiat-ar-prod-fca.adobecqms.net/concesionarios.html
                        </a>
                        ) o de manera online en nuestro sitio (
                        <a href="/">www.fiatplan.com.ar</a>). <br /> Nuestra
                        única web oficial para la suscripción online es{" "}
                        <a href="/">www.fiatplan.com.ar</a> y no poseemos otras
                        cuentas ni direcciones web ni redes sociales.
                        <br />
                        Fiat Plan no realiza llamados ni publicaciones como
                        “Plan Nacional", “Casa Central” ni “desde fábrica”.
                    </p>
                </div>
                <div className="mandamiento">
                    <h2 className="title">
                        PODRÁS RENUNCIAR AL PLAN PERO EL DINERO SE TE
                        REINTEGRARÁ UNA VEZ FINALIZADO EL TIEMPO ESTIPULADO
                    </h2>
                    <p className="desc">
                        En el caso que no puedas continuar abonando tus cuotas y
                        aún no hayas retirado el auto, podrás renunciar al plan.
                        La devolución de tu dinero se hará a partir de la cuota
                        84, una vez finalizado el plan, de acuerdo al Valor
                        Móvil (valor del modelo de ahorro) vigente y realizando
                        las deducciones correspondientes y los conceptos
                        diferidos no abonados.
                    </p>
                </div>
                <div className="mandamiento">
                    <h2 className="title">
                        Y AUNQUE EXISTA LA ADJUDICACIÓN PACTADA, DEBERÁS CUMPLIR
                        CON TODOS LOS REQUISITOS ESTABLECIDOS
                    </h2>
                    <p className="desc">
                        Una vez que resultás adjudicado, ya sea por adjudicación
                        pactada o por sorteo o licitación, deberás abonar en
                        todos los casos el Derecho de Adjudicación y también la
                        Alícuota Extraordinaria y el Cambio de Modelo (si
                        corresponden) – Además el concesionario se contactará
                        con vos para completar los requisitos crediticios y la
                        documentación del pedido del auto.
                    </p>
                </div>
                <div className="mandamiento">
                    <h2 className="title">
                        SABRÁS QUE LA CUOTA NO ES FIJA Y VARÍA SEGÚN EL PRECIO
                        DEL 0 KM A LO LARGO DEL PLAN
                    </h2>
                    <p className="desc">
                        Cada cuota pura del plan se calcula sobre el precio del
                        modelo de ahorro del grupo (es un % del valor del auto).
                        De esta manera, cualquier variación del precio del auto
                        que estás ahorrando impactará en el valor de la cuota.
                    </p>
                </div>

                <p className="body-faq">
                    Te invitamos a visitar nuestra sección PREGUNTAS FRECUENTES{" "}
                    <br />(
                    <a href="/conoce_fiat_plan">
                        https://www.fiatplan.com.ar/conoce_fiat_plan
                    </a>
                    ) para ampliar toda la información que necesites conocer
                    sobre FIAT PLAN.
                </p>
                <div className="body-foot">
                    <div>
                        <h1 className="subtitle">MANDAMIENTOS FIAT PLAN</h1>
                        <h2 className="title">
                            QUE TU PLAN PARA TENER UN AUTO SEA TAN CLARO COMO
                            LAS GANAS DE TENERLO
                        </h2>
                    </div>
                    <div className="logo-container">
                        <img
                            src="/img/fiatplan-pactoclaro.png"
                            alt="FIAT PLAN & Pacto Claro"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
